import { PromotionFilterInput } from '@/fo/api/magento';

import { FILTERS_SLUG, PROMOTION_TYPES_VALUES } from '../constants';

export const prepareFilters = (params: {
  [key: string]: string | string[];
}): PromotionFilterInput => {
  if (!params) return {};
  const filters: PromotionFilterInput = Object.entries(
    params
  ).reduce<PromotionFilterInput>((acc, [slug, values]) => {
    if (!values || (Array.isArray(values) && values.length === 0)) return acc;

    if (slug === FILTERS_SLUG.TYPE) {
      if (values === PROMOTION_TYPES_VALUES.ALL) {
        return {
          ...acc,
          [slug]: undefined
        };
      }

      return {
        ...acc,
        [slug]: {
          eq: Array.isArray(values) ? values[0] : values
        }
      };
    }

    return {
      ...acc,
      [slug]: {
        in: Array.isArray(values) ? values : [values]
      }
    };
  }, {});

  return filters;
};
